let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("j2Tdl")]).then(() => parcelRequire('al5TY'));